import { IModalChangePropsReducer, IModalCloseReducer, IModalOpenReducer } from "./ModalsReducer";

export const MODAL_ACTIONS_OPEN = 'MODAL_ACTIONS_OPEN';
export const MODAL_ACTIONS_CHANGE_PROPS = 'MODAL_ACTIONS_CHANGE_PROPS';
export const MODAL_ACTIONS_CLOSE = 'MODAL_ACTIONS_CLOSE';

export interface ModalsActionsOpen {
  type: typeof MODAL_ACTIONS_OPEN,
  payload: IModalOpenReducer
}

export interface ModalsActionsChangeProps {
  type: typeof MODAL_ACTIONS_CHANGE_PROPS,
  payload: IModalChangePropsReducer
}

export interface ModalsActionsClose {
  type: typeof MODAL_ACTIONS_CLOSE,
  payload: IModalCloseReducer
}

export type ModalsActionTypes = ModalsActionsOpen | ModalsActionsChangeProps | ModalsActionsClose;